import ReactHtmlParser from 'react-html-parser';

import { FormSubmitScreen } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

import { getAppConfig } from '../../../common/utilities';

const FormSubmissionPage = ({
  messages: { successMessage, failureMessage },
  labels: { successHeader, failureHeader, successButtonLabel, failureButtonLabel },
  handleCloseModal,
  onReturn,
  isSuccess
}) => {
  const { host, path } = getAppConfig('server');
  const successMessageText = successMessage.replace('/customerrequests', `${host}${path}/customerrequests`);
  const submitLabels = {
    header: isSuccess ? successHeader : failureHeader,
    message: isSuccess ? ReactHtmlParser(successMessageText) : failureMessage,
    successButtonLabel,
    failureButtonLabel
  };
  return (
    <FormSubmitScreen
      labels={submitLabels}
      success={isSuccess}
      onSuccessButtonClick={handleCloseModal}
      onReturnClick={onReturn}
    />
  );
};

FormSubmissionPage.propTypes = {
  labels: PropTypes.instanceOf(Object).isRequired,
  messages: PropTypes.instanceOf(Object).isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  onReturn: PropTypes.func.isRequired,
  isSuccess: PropTypes.bool.isRequired
};

export default FormSubmissionPage;
